import { ParametrosService } from './parametros.service';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { EtapaModel } from '../model/etapa.model';
import { GenericHttpService } from '../../shared/generic-http.service';
import { ConfiguracoesProjeto } from './../../shared/model/configuracoes-projeto.model';

@Injectable()
export class EtapaService {

    private _urlBase: string;
    private configuracao: ConfiguracoesProjeto;

    private etapas: EtapaModel[];
    public etapasChange = new Subject<EtapaModel[]>();
    public etapasErro = '';

    constructor(private readonly genericHttpService: GenericHttpService<EtapaModel>,
                private readonly parametrosService: ParametrosService) { }

    get urlBase() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBase = this.configuracao.uri  +  'etapa/';

        return this._urlBase;
    }

    getEtapas() {
        const api = `listagem`;

        this.genericHttpService.getById(this.urlBase + api).subscribe(
            (data: any) => {
                this.etapas = (<EtapaModel[]>data);
                this.etapasErro = '';
                this.etapasChange.next(this.etapas.slice());
            },
            (error: any) => {
                this.etapas = [];
                this.etapasErro = error;
                this.etapasChange.next(this.etapas.slice());
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/etapa.service.ts